import { useState } from "react";
import { Check, Copy, Download, Link2, Loader2, RefreshCw } from "lucide-react";
import { QRCodeCanvas } from "qrcode.react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { errMsg, useApi } from "@/lib/api";

export const PesertaShare = ({ kajian, onChange }) => {
  const api = useApi();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);
  const url = kajian.peserta_kod ? `${window.location.origin}/peserta/${kajian.peserta_kod}` : "";
  const call = async (body, msg) => {
    setBusy(true);
    try { onChange(await api("post", `/hte/kajian/${kajian.id}/peserta-link`, body)); if (msg) toast.success(msg); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const start = () => { setOpen(true); if (!kajian.peserta_aktif) call({ aktif: true }, "Pautan peserta diaktifkan"); };
  const downloadQr = () => {
    const c = document.getElementById("peserta-qr");
    if (!c) return;
    const big = document.createElement("canvas");
    big.width = big.height = 1024;
    const ctx = big.getContext("2d");
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(c, 0, 0, 1024, 1024);
    const a = document.createElement("a");
    a.href = big.toDataURL("image/png"); a.download = `QR Peserta - ${kajian.tajuk}.png`; a.click();
  };
  const copy = async () => { try { await navigator.clipboard.writeText(url); setCopied(true); setTimeout(() => setCopied(false), 1500); } catch { toast.error("Gagal menyalin"); } };
  return (
    <>
      <button onClick={start} data-testid="peserta-share-button" className={`h-9 px-4 rounded-full border text-sm inline-flex items-center gap-2 transition-colors ${kajian.peserta_aktif ? "border-[var(--i)] text-i" : "border-line hover:bg-surface"}`}>
        <Link2 size={14} /> Kongsi kepada Peserta{kajian.peserta_aktif ? " ✓" : ""}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="peserta-share-dialog">
          <DialogHeader><DialogTitle>Pautan peserta (baca sahaja)</DialogTitle></DialogHeader>
          <p className="text-sm text-mute">Peserta boleh membuka pautan ini tanpa log masuk. Mereka hanya melihat tajuk program, ayat utama, Soalan Refleksi dan Tindakan Peserta, serta boleh menghantar borang maklum balas (nama, telefon dan e-mel adalah pilihan).</p>
          {busy && !url ? <Loader2 className="animate-spin text-q" /> : kajian.peserta_aktif && url ? (
            <div className="space-y-3">
              <div className="flex gap-2">
                <input readOnly value={url} className="flex-1 h-10 px-3 rounded-xl bg-bg border border-line text-xs font-mono-data" data-testid="peserta-share-url" />
                <button onClick={copy} className="h-10 px-4 rounded-full bg-ink text-bg text-sm inline-flex items-center gap-2" data-testid="peserta-share-copy">{copied ? <Check size={14} /> : <Copy size={14} />} Salin</button>
              </div>
              <div className="flex items-center gap-4" data-testid="peserta-share-qr">
                <div className="bg-white p-3 rounded-xl border border-line"><QRCodeCanvas id="peserta-qr" value={url} size={160} marginSize={1} /></div>
                <div className="space-y-2">
                  <p className="text-xs text-mute">Imbas untuk membuka bahan peserta. Paparkan pada slaid atau cetak.</p>
                  <button onClick={downloadQr} className="h-9 px-4 rounded-full border border-line text-sm inline-flex items-center gap-2" data-testid="peserta-share-qr-download"><Download size={14} /> Muat turun QR (PNG)</button>
                </div>
              </div>
              <div className="flex flex-wrap gap-2">
                <a href={url} target="_blank" rel="noreferrer" className="h-9 px-4 rounded-full border border-line text-sm inline-flex items-center" data-testid="peserta-share-open">Buka pautan</a>
                <button onClick={() => call({ aktif: true, baharu: true }, "Pautan baharu dicipta; pautan lama tidak lagi berfungsi")} disabled={busy} className="h-9 px-4 rounded-full border border-line text-sm inline-flex items-center gap-2" data-testid="peserta-share-regenerate"><RefreshCw size={14} /> Tukar pautan</button>
                <button onClick={() => call({ aktif: false }, "Pautan dimatikan")} disabled={busy} className="h-9 px-4 rounded-full border border-line text-sm text-warn" data-testid="peserta-share-disable">Matikan pautan</button>
              </div>
            </div>
          ) : (
            <button onClick={() => call({ aktif: true }, "Pautan peserta diaktifkan")} disabled={busy} className="h-10 px-5 rounded-full bg-ink text-bg text-sm font-semibold" data-testid="peserta-share-enable">Aktifkan pautan</button>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
